import { IVehicle } from "./vehicle.model";

export interface IVehicleFromUsers extends IVehicle {
  color: string;
  licenseplate: string;
  modelName: string;
  modelYear: string;
  preferredDealer: string;
  vehicleType: string;
  vin: string;
}

export interface IVehicleDetailsBFF extends IVehicle {
	fuelType: string;
  vehicleLineFeatureCode: string;
  type?: string;
}

 